import React from "react";
import { IconCopy, IconExclamationMark } from "@tabler/icons-react";
import useToast from "hooks/useToast";
import MainLayout from "layouts/MainLayout";
import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL } from "utils";
import { useParams } from "react-router";

const BuildingNoLicense = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const { id: buildingID } = useParams();

  const copyBuildingID = () => {
    if (buildingID === undefined) return;
    navigator.clipboard.writeText(buildingID);
    toast(t("dashboard.buildingIDCopiedMessage"), "success");
  };

  const copyEmailAddress = () => {
    navigator.clipboard.writeText(SUPPORT_EMAIL);
    toast(t("dashboard.emailCopiedMessage"), "success");
  };

  return (
    <MainLayout className="flex justify-center items-center">
      <div className="max-w-[550px] flex flex-col items-center justify-center">
        <div className="flex items-center p-4 mb-2">
          <IconExclamationMark
            size={16}
            stroke={3}
            className="text-red-500 bg-red-100 rounded-full min-w-[24px] min-h-[24px] p-1 mr-2"
          />
          <div className="text-red-700 text-xs bg-transparent border-none font-medium">
            {t("building.buildingNoLicense", {
              id: buildingID,
            })}
          </div>
        </div>
        <div className="flex flex-col justify-center items-center font-semibold text-indigo-700">
          <div
            className="text-xs mb-2 flex items-center h-6 cursor-pointer"
            onClick={copyBuildingID}
          >
            <IconCopy stroke={3} className="w-4 h-4 mr-1" size={16} />
            <span>{t("building.copyBuildingID")}</span>
          </div>
          <div
            className="text-xs flex items-center h-6 cursor-pointer"
            onClick={copyEmailAddress}
          >
            <IconCopy stroke={3} className="w-4 h-4 mr-1" size={16} />
            <span>{t("organisationSettings.copyEmailAddress")}</span>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default BuildingNoLicense;
